import React from 'react';

export const OverviewIcon = ({ fill, width, height, className }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_54_98)">
                <mask id="mask0_54_98" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="67" height="67">
                    <path d="M66.27 0H0V66.27H66.27V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_54_98)">
                    <path d="M50.5859 33.1328C57.7651 33.1328 60.7472 30.3716 58.0965 21.3147C56.3016 15.2123 51.0553 9.96593 44.9529 8.17112C35.896 5.52032 33.1348 8.50247 33.1348 15.6817V23.6341C33.1348 30.3716 35.896 33.1328 41.4185 33.1328H50.5859Z" fill="#E1F4D3" stroke="#1C452B" strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M55.225 40.5898C52.6571 53.3744 40.3971 62.6522 26.4527 60.3879C15.9875 58.7036 7.56573 50.2818 5.85376 39.8166C3.61715 25.9275 12.8397 13.6675 25.5691 11.072" stroke="#1C452B" strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_54_98">
                    <rect width="66.27" height="66.27" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};
